<rb-choose-theme />
<div
  class="bg-surface-50 dark:bg-surface-950 flex items-center justify-center min-h-screen min-w-[100vw] overflow-hidden">
  <div class="flex flex-col items-center justify-center">
    <div>
      <div class="w-full py-20 px-8 sm:px-20">
        <div class="text-center mb-4">
          <img
            class="mb-8 w-72 shrink-0 mx-auto"
            ngSrc="/img/logo-cir.png"
            priority
            width="340"
            height="150"
            [alt]="'topbar.brand' | translate" />
          <div class="text-surface-900 dark:text-surface-0 text-3xl font-medium mb-2">
            {{ 'login.title' | translate }}
          </div>
        </div>
        <div class="bg-surface-0 dark:bg-surface-900 py-10 px-10 shadow-md" style="border-radius: 1rem">
          <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" autocomplete="off">
            <label class="block text-surface-900 dark:text-surface-0 text-xl font-medium mb-2" for="username1">{{
              'login.usernameLabel' | translate
            }}</label>
            <p-iconfield class="w-full md:w-[30rem] mb-8">
              <p-inputicon styleClass="pi pi-user" />
              <input
                pSize="large"
                formControlName="username"
                id="username1"
                type="text"
                pInputText
                pButtonIcon="pi pi-user"
                fluid
                [placeholder]="'login.usernamePlaceholder' | translate"
                autocomplete="new-username" />
            </p-iconfield>

            <label class="block text-surface-900 dark:text-surface-0 font-medium text-xl mb-2" for="password1">{{
              'login.passwordLabel' | translate
            }}</label>
            <p-iconfield class="w-full md:w-[30rem] mb-12">
              <p-inputicon styleClass="pi pi-lock" style="z-index: 9" />
              <p-password
                size="large"
                inputId="password1"
                formControlName="password"
                [feedback]="false"
                [toggleMask]="true"
                [fluid]="true"
                [placeholder]="'login.passwordPlaceholder' | translate" />
            </p-iconfield>

            <p-button
              size="large"
              fluid
              type="submit"
              [label]="'login.signIn' | translate"
              [disabled]="!loginForm.valid"></p-button>
            @if (showForgottenPasswordLink()) {
              <div class="flex justify-end mt-3">
                <a
                  class="font-medium no-underline ml-2 text-right cursor-pointer text-primary"
                  [routerLink]="'/create-forgot-password-request'">
                  {{ 'login.forgottenPassword' | translate }}
                </a>
              </div>
            }
          </form>
        </div>
        <div class="mx-auto my-8">
          <rb-environment />
        </div>
      </div>
    </div>
    <rb-footer />
  </div>
</div>
